import { OptionProps } from 'ui/Select';
import * as Types from './students.types';

export const studentOptionMapper = (
    items: Types.StudentDetail[]
): OptionProps[] =>
    items.map((item) => ({
        label: item.fullName ?? undefined,
        value: item.id!
    }));
